import React from 'react';
import { ContactForm } from './ContactForm';
import { ContactInfo } from './ContactInfo';

export function ContactHero() {
  return (
    <div className="py-16 bg-black/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Get in Touch with Priority AI Services
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            We're here to help! Contact us for any inquiries, consultations, or service questions. 
            Our team will respond promptly.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <ContactForm />
          </div>
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Contact Information</h3>
              <ContactInfo />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Operating Hours</h3>
              <p className="text-gray-400">
                9a-5p every day
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}